import { Pipe, PipeTransform } from '@angular/core';

import { FormGroup } from '@angular/forms';

@Pipe({
  name: 'customFilterOptions',
  pure: false,
  standalone: false,
})
export class CustomFilterOptionsPipe implements PipeTransform {
  /**
   * @param options - Original array of options.
   * @param formGroup - The reactive form group instance.
   * @param filterFn - Optional custom filter function that receives the formGroup and returns a filtered list.
   */
  transform(
    options: any[],
    formGroup: FormGroup,
    filterFn?: (formGroup: FormGroup) => any[],
  ): any[] {
    if (!options || !formGroup) {
      return options;
    }

    // If a custom filter function is provided, call it with the formGroup.
    if (filterFn && typeof filterFn === 'function') {
      return filterFn(formGroup);
    }

    // Default behavior: return the options as-is.
    return options;
  }
}
